
const Footer = () => {
  return (
    <div className="text-center p-3  mt-auto" >
      Tasneem ASAC© 2023 Copyright:

    </div>
 
  );
};

export default Footer;